export default {
    ModuleSwitch: {
        datapoint: {
            eventName: 'ModuleSwitch',
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
             * See aka.ms/mini-lint-errors
             *	> Unexpected any. Specify a different type.
             *	> Unexpected any. Specify a different type. */
            customData: (fromModule: string, toModule: string): [any, any] => [
                fromModule,
                toModule,
            ],
            options: { isCore: true },
        },
    },
};
